import Vue from 'vue'
import Router from 'vue-router'

import Changes from '../components/views/Changes'
import Auth from '../components/views/Auth'
import Products from '../components/views/Products'
import ProductGroups from '../components/views/ProductGroups'
import Versions from '../components/views/Versions'
import Callback from '../components/views/Callback'
import Silent from '../components/views/Silent'
import History from '../components/views/History'
import ProfileSettings from '../components/views/ProfileSettings'
import ChangesSaving from '../components/views/ChangesSaving'
import AdminPanel from '../components/views/AdminPanel'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/changes', component: Changes },
    { path: '/auth', component: Auth },
    { path: '/products', component: Products },
    { path: '/productGroups', component: ProductGroups },
    { path: '/versions', component: Versions},
    { path: '/callback', component: Callback},
    { path: '/silent', component: Silent},
    { path: '/logs', component: History},
    { path: '/', component: Changes},
    { path: '/profileSettings', component: ProfileSettings},
    { path: '/changesSaving', component: ChangesSaving },
    { path: '/admin', component: AdminPanel }
    // { path: '/board/:id', name: 'board', component: Board, props: true }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js